import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { DamEcoModeVersion } from '~/providers/types/damEcoMode';
import { ECO_MODE_LABEL_KEYS } from '../constants';
import {
  ActiveModeBadge, ScreenHeader, ScreenTab, ScreenTabs, StatusPill,
} from '../styles';

interface EcoModeScreenTabsProps {
  screens: DamEcoModeVersion[];
  selected: DamEcoModeVersion;
  activeMode: DamEcoModeVersion;
  onSelect: (mode: DamEcoModeVersion) => void;
  /** Selo de conexão do design, exibido na tela do Modo Eco simplificado. */
  status: { visible: boolean; online: boolean };
}

/** Abas das telas do Modo Eco (só para quem vê as duas) e o selo de conexão do DAM. */
export function EcoModeScreenTabs({
  screens,
  selected,
  activeMode,
  onSelect,
  status,
}: Readonly<EcoModeScreenTabsProps>): ReactElement | null {
  const { t } = useTranslation();
  const hasTabs = screens.length > 1;
  if (!hasTabs && !status.visible) return null;

  return (
    <ScreenHeader>
      {hasTabs ? (
        <ScreenTabs role="tablist">
          {screens.map((screen) => (
            <ScreenTab
              key={screen}
              type="button"
              role="tab"
              aria-selected={selected === screen}
              $selected={selected === screen}
              onClick={() => onSelect(screen)}
              data-testid={`eco-modo-tela-${screen}`}
            >
              {t(ECO_MODE_LABEL_KEYS[screen])}
              {activeMode === screen ? <ActiveModeBadge>{t('ecoSimplificadoModoAtivo')}</ActiveModeBadge> : null}
            </ScreenTab>
          ))}
        </ScreenTabs>
      ) : null}
      {status.visible ? (
        <StatusPill $online={status.online} data-testid="eco-simplificado-status">
          {status.online ? t('online') : t('offline')}
        </StatusPill>
      ) : null}
    </ScreenHeader>
  );
}
